var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.6,11c.4-.5,1.5-1,2.4-1.1,2.1-.2,3.9,1.6,4.2,3.8.2,1.7-1,3.7-2.5,4.2",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "21.7 8.7 22.9 6.5 24.6 7.9 26.1 7.5 27.1 5.5 29.9 6.1 30.3 8.3 31.3 9.1 33.4 8.6 35 11.1 33.3 12.8 33.6 14.3 35.4 15 34.7 18 32.9 18.1 32 19.3 32.3 21.1 31.2 22.6 29.2 21",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinejoin: "bevel",
      strokeWidth: "1.3px"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -5.4,
    y: -4.3,
    width: 43.4,
    height: 64.2,
    transform: "translate(-11.2 10.9) rotate(-28.1)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 34.4,
    x2: 17,
    y2: 24.8,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 20.4,
    r: 2.1,
    style: {
      fill: "#0194d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7,24.8c-1-1.2-1.6-2.7-1.6-4.4,0-3.8,3.1-6.9,6.9-6.9",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1,12.3c1.9-1.6,4.3-2.5,6.9-2.5,5.9,0,10.6,4.8,10.6,10.6,0,2.6-1,5-2.5,6.9",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3,29.4c-1.8-1.2-3.3-2.9-4.2-4.9",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,9.8c5.9,0,10.6,4.8,10.6,10.6",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7,15.4c1.3,1.3,2.1,3,2.1,5s-.3,2.4-.9,3.4",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/admin-icon.d45023eb9e117e75669052178a7e5cc1.svg";
export { ForwardRef as ReactComponent };